// components/common/modal/BaseModal.tsx
import React from 'react';
import { Dialog, DialogProps } from '@mui/material';

interface BaseModalProps extends Omit<DialogProps, 'open'> {
    open: boolean;
    onClose?: () => void;
    children: React.ReactNode;
    maxWidth?: DialogProps['maxWidth'];
    fullWidth?: boolean;
}

export const BaseModal = ({ open, onClose, children, maxWidth = 'md', fullWidth = true, ...props }: BaseModalProps) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 2,
                        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                        overflow: 'hidden',
                        height: 'auto',
                        maxHeight: '90vh', // Limit height to 90% of viewport
                        display: 'flex',
                        flexDirection: 'column',
                    },
                },
            }}
            {...props}
        >
            {children}
        </Dialog>
    );
};
